var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-service-enter",on:{"click":_vm.openCustomerServicePage}},[_c('dol-icon',{staticClass:"customer-service-icon",attrs:{"type":"customer"}}),_c('div',{staticClass:"customer-service-text"},[_vm._v(_vm._s(_vm.$t('客服_联系客服')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }